
export function combinations(n, k) { // n choose k
    // Handle edge cases
    if (k < 0 || k > n) {
        return 0;
    }
    if (k === 0 || k === n) {
        return 1;
    }
    if (k > n / 2) {
        k = n - k; // Optimize by choosing the smaller k
    }

    // Calculate combinations using a simplified approach to avoid large factorials
    let result = 1;
    for (let i = 1; i <= k; i++) {
        result = result * (n - i + 1) / i;
    }
    return result;
}
export function generateRoundRobinSchedule(teams) { // Circle Method - from google
    // generates array of rounds with matched teams
    // a round is an array of matches where each match is an array of two teams
    // i'ts possible for all matches in a round to be played simultaneously
    // Though there are no simultaneous matches, it could be useful to keep rounds separate. e.g. preventing back-to-back games
    const numTeams = teams.length;
    if (numTeams % 2 !== 0) {
        // Add a dummy team for an odd number of participants to ensure the algorithm works
        teams.push("BYE");
    }
    const numRounds = numTeams - 1;
    const halfSize = numTeams / 2;
    const schedule = [];
    const participants = [...teams]; // Use a copy to avoid modifying the original array

    for (let round = 0; round < numRounds; round++) {
        const currentRoundMatches = [];
        for (let i = 0; i < halfSize; i++) {
            const team1 = participants[i];
            const team2 = participants[numTeams - 1 - i];

            // Only add matches that do not involve the "BYE" dummy team
            if (team1 !== "BYE" && team2 !== "BYE") {
                currentRoundMatches.push([team1, team2]);
            }
        }
        schedule.push(currentRoundMatches);

        // Rotate participants: keep the first team fixed, rotate the rest counter-clockwise
        const firstTeam = participants[0];
        const restOfTeams = participants.slice(1);
        participants.length = 0; // Clear the array
        participants.push(firstTeam);
        // Push the last element of the rest to the second position to simulate counter-clockwise rotation
        participants.push(restOfTeams[restOfTeams.length - 1]);
        participants.push(...restOfTeams.slice(0, restOfTeams.length - 1));
    }

    return schedule;
}